<template>
  <document-content
    url_prefix="/client/v2/clients"
    v-bind:client_ids="activeEntrepriseIds" />
</template>
<script setup lang="ts">
  import DocumentContent from '@/components/refonte/documents/document-content.vue';
  import { storeToRefs } from 'pinia';
  import { useEntrepriseStore } from '@/stores/entreprise';
  const entrepriseStore = useEntrepriseStore();

  const { activeEntrepriseIds } = storeToRefs(entrepriseStore);
</script>

<style lang="scss" scoped></style>
